import { Box, Grid } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import {
  InboxSidebarOptionKey,
  OutreachContactsContext,
} from "contexts/OutreachContacts";
import { useContext } from "react";

import SearchBar from ".";
import InboxFilters from "./Filters/InboxFilters";
import SortSelect from "./Filters/SortSelect";

const InboxSearchBarMenu = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { currentSidebarOption } = useContext(OutreachContactsContext);
  return (
    <Grid>
      {currentSidebarOption?.key !== InboxSidebarOptionKey.checkins && (
        <Grid container alignItems="center" gap={2}>
          <Grid
            item
            xs
            md={!currentOrg?.isBrand ? 6 : true}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Box sx={{ flex: 1 }}>
              <SearchBar />
            </Box>
            <InboxFilters />
          </Grid>
          <Grid item xs="auto" md="auto">
            <SortSelect />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default InboxSearchBarMenu;
